// extracted by mini-css-extract-plugin
export default {"search":"WarehouseStockToolbar_search__muvWy","icon":"WarehouseStockToolbar_icon__MVpU9","placeHolderShimmer":"WarehouseStockToolbar_placeHolderShimmer__KIlVP"};